// Shared copy and link for the Sudoku Flags house promo, used by both the ad
// slots (components/AdBanner.tsx) and the header banner
// (components/SudokuFlagsBanner.tsx). No em dashes in the copy.

export const SUDOKUFLAGS_LINK = 'https://sudokuflags.com/?utm_source=calculatorscope&utm_medium=banner'
export const SUDOKUFLAGS_BRAND = 'Sudoku Flags'

export type SudokuFlagsCopy = { text: string; cta: string }

export const SUDOKUFLAGS_COPY: Record<string, SudokuFlagsCopy> = {
  en: { text: 'Sudoku with country flags, free to play.', cta: 'Play now' },
  ru: { text: 'Судоку с флагами стран, играть бесплатно.', cta: 'Играть' },
  de: { text: 'Sudoku mit Länderflaggen, kostenlos spielen.', cta: 'Jetzt spielen' },
  es: { text: 'Sudoku con banderas de países, gratis para jugar.', cta: 'Jugar' },
  fr: { text: 'Sudoku avec les drapeaux des pays, gratuit.', cta: 'Jouer' },
  it: { text: 'Sudoku con le bandiere dei paesi, gratis.', cta: 'Gioca' },
  pl: { text: 'Sudoku z flagami państw, graj za darmo.', cta: 'Zagraj' },
  lv: { text: 'Sudoku ar valstu karogiem, spēlē bez maksas.', cta: 'Spēlēt' },
}

export function sudokuflagsCopy(lang: string): SudokuFlagsCopy {
  return SUDOKUFLAGS_COPY[lang] || SUDOKUFLAGS_COPY.en
}
